module.exports = __webpack_public_path__ + "img/qrcode.5c7eabe3.png";